import { render, staticRenderFns } from "./invoiceRecords.vue?vue&type=template&id=b7e15d28&scoped=true"
import script from "./invoiceRecords.vue?vue&type=script&lang=js"
export * from "./invoiceRecords.vue?vue&type=script&lang=js"
import style0 from "./invoiceRecords.vue?vue&type=style&index=0&id=b7e15d28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e15d28",
  null
  
)

export default component.exports